import trackReferral from "@faire/web-api/api/r2r-referrals/owf/referralCode/post";
import { trackOpenWithFaireOwfR2RCreateReferralLinkSubmit } from "@faire/web-api/events/openWithFaire/submit/owfR2RCreateReferralLink";
import { QueryParameters as owfLandingPageQueryParameters } from "@faire/web-api/routes/open-with-faire";
import { logError } from "@faire/web/common/logging";
import { Storage } from "@faire/web/common/Storage";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useEffect } from "react";

import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useOpenWithFaireStore } from "@faire/retailer/stores/domain/OpenWithFaireStore";

export const OWF_REFERRAL_CODE_KEY = "OWF_REFERRAL_CODE";

export const useCreateOwFR2RLinkEffect = () => {
  const { canBeReferred } = useOpenWithFaireStore(["canBeReferred"]);

  const isLoggedInRetailer = useIsLoggedInRetailer();
  const queryParams = useQueryParams(owfLandingPageQueryParameters.parse);
  const { ref } = queryParams;
  const sessionRef = Storage.session.getItem(OWF_REFERRAL_CODE_KEY);
  const owfR2RRefCode = ref ?? sessionRef;

  useEffect(() => {
    if (!owfR2RRefCode) {
      return;
    }
    if (!isLoggedInRetailer) {
      Storage.session.setItem(OWF_REFERRAL_CODE_KEY, owfR2RRefCode);
      return;
    }
    if (canBeReferred()) {
      createReferralLink(owfR2RRefCode);
    }
  }, [canBeReferred, isLoggedInRetailer, owfR2RRefCode]);
};

const createReferralLink = async (referralCode: string) => {
  try {
    trackOpenWithFaireOwfR2RCreateReferralLinkSubmit();
    await trackReferral(referralCode);
    Storage.session.removeItem(OWF_REFERRAL_CODE_KEY);
  } catch (error) {
    logError(error, { tags: { source: "OwF_R2R_Pilot" } });
  }
};
